import React from 'react';
import { Layout } from '@/components/layout/Layout';
import { legalContent, siteInfo } from '@/data/mock';
import { FileText, Mail, Phone, ExternalLink } from 'lucide-react';

const MentionsLegalesPage = () => {
  return (
    <Layout>
      {/* Hero */}
      <section className="pt-32 pb-16 bg-[var(--surface-cream)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <div className="flex justify-center mb-6">
              <div className="feature-icon !w-16 !h-16">
                <FileText className="w-7 h-7" />
              </div>
            </div>
            <h1 className="font-serif text-4xl sm:text-5xl text-[var(--text-primary)] mb-6">
              Mentions Légales
            </h1>
            <div className="w-24 h-px bg-[var(--color-gold)] mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Quick Info Cards */}
          <div className="grid sm:grid-cols-2 gap-6 mb-12">
            <div className="p-6 bg-[var(--surface-cream)] rounded-xl">
              <h3 className="font-medium text-[var(--text-primary)] mb-4">Contact</h3>
              <div className="space-y-3">
                <a
                  href={`tel:${siteInfo.phone.replace(/\s/g, '')}`}
                  className="flex items-center gap-3 text-[var(--text-secondary)] hover:text-[var(--color-gold)] transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  {siteInfo.phone}
                </a>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="flex items-center gap-3 text-[var(--text-secondary)] hover:text-[var(--color-gold)] transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  {siteInfo.email}
                </a>
              </div>
            </div>
            <div className="p-6 bg-[var(--surface-cream)] rounded-xl">
              <h3 className="font-medium text-[var(--text-primary)] mb-4">Informations</h3>
              <p className="text-sm text-[var(--text-secondary)]">
                SIRET: {siteInfo.siret}<br />
                Code APE: 0149Z<br />
                Dirigeante: Liza GUENODEN
              </p>
            </div>
          </div>

          {/* Full Legal Text */}
          <div className="prose prose-lg max-w-none">
            {legalContent.mentionsLegales.split('\n\n').map((section, index) => {
              // Check if it's a title (all caps)
              const isTitle = section === section.toUpperCase() && section.length < 100;
              
              if (isTitle) {
                return (
                  <h2 key={index} className="font-serif text-xl text-[var(--text-primary)] mt-12 mb-4 border-b border-[var(--color-beige)] pb-2">
                    {section}
                  </h2>
                );
              }
              
              return (
                <p key={index} className="text-[var(--text-secondary)] leading-relaxed mb-4">
                  {section}
                </p>
              );
            })}
          </div>

          {/* External Links */}
          <div className="mt-12 p-6 bg-[var(--surface-cream)] rounded-xl">
            <h3 className="font-medium text-[var(--text-primary)] mb-4">Liens utiles</h3>
            <div className="space-y-3">
              <a
                href="https://www.bloctel.gouv.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[var(--text-secondary)] hover:text-[var(--color-gold)] transition-colors"
              >
                <ExternalLink className="w-4 h-4" />
                Bloctel - Opposition au démarchage téléphonique
              </a>
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[var(--text-secondary)] hover:text-[var(--color-gold)] transition-colors"
              >
                <ExternalLink className="w-4 h-4" />
                Plateforme de règlement des litiges en ligne (UE)
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default MentionsLegalesPage;
